const moduleName = '.issues'

export default ({ clientWrapper, context }) => ({
  searchByQuery: (query, issueType) => {
    context.lastApiPath = `${moduleName}.searchByQuery`

    return clientWrapper.api.get(`/headings/${issueType}/search`, {
      params: { q: query }
    }).then(({ data }) => data.map(item => item.attributes))
  },

  allCountries: () => {
    context.lastApiPath = `${moduleName}.allCountries`

    return clientWrapper.api.get('/countries')
  }
})
